import { render, staticRenderFns } from "./positioningReward.vue?vue&type=template&id=91232ba0&scoped=true&"
import script from "./positioningReward.vue?vue&type=script&lang=js&"
export * from "./positioningReward.vue?vue&type=script&lang=js&"
import style0 from "./positioningReward.vue?vue&type=style&index=0&id=91232ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91232ba0",
  null
  
)

export default component.exports